angular.module('dat.shared-components.common', []);
